import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import { Loading } from "../components/Loading";
import ErrorMessageBox from "../components/ErrorMessageBox";
import { setSchool } from "./ducks/school";

const SchoolList = () => {
    const dispatch = useDispatch();
    const schoolList = useSelector(state => state.schoolList);
    const navigate = useNavigate();

    const gotoSchoolPage = useCallback((school) => {
        sessionStorage.setItem("school", school.code);
        dispatch(setSchool(school));
        navigate(school.code);
    }, [dispatch, navigate]);

    const latestSchool = useMemo(() => {
        const code = sessionStorage.getItem('schoolCode');
        const name = sessionStorage.getItem('schoolName');
        if (code === null || name === null) return null;
        return { code, name };
    }, []);

    if (schoolList.loading) return <Loading />;
    if (schoolList.result === null) {
        if (latestSchool === null) return null;
        return (
            <div>
                <p>최근 접속한 학교</p>
                <ul>
                    <li>
                        <button className="school" onClick={(e) => gotoSchoolPage(latestSchool)}>
                            <strong>{latestSchool.name}</strong>
                        </button>
                    </li>
                </ul>
            </div>
        );
    }//end null

    if (null !== schoolList.message) return <ErrorMessageBox message={schoolList.message} />
    if (schoolList.list.length <= 0) return <p>일치하는 학교가 없습니다.</p>;

    let html = schoolList.list.map((school, key) => {
        return (
            <li key={key}>
                <button onClick={e => gotoSchoolPage(school)}>
                    <strong>{school.name}</strong><span>{school.cityName}</span>
                </button>
            </li>
        )
    });

    return (
        <>
            <p><strong>{schoolList.totalElements}</strong>개의 학교가 있습니다.</p>
            <ul>
                {html}
            </ul>
        </>
    );
}
export default SchoolList;